import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { I18nService } from 'i18n';
import { Logger } from 'shared';

/**
 * Allows access to the KYC form only when kyc_status === 1 (requested).
 * Any other status means the data has already been submitted or is no longer editable.
 */
export const kycFormGuard: CanActivateFn = (route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const i18nService = inject(I18nService);
  const logger = new Logger('kycFormGuard');

  return authService.getUser$().pipe(
    take(1),
    map(user => {
      if (!user) {
        logger.debug('NO USER => REDIRECT TO /login');
        return false;
      }

      if (user.kyc_status === 1) {
        logger.debug(`kyc_status=1 => CAN ACTIVATE: ${route.url}`);
        return true;
      }

      const lang = i18nService.getLanguage();
      logger.debug(`kyc_status=${user.kyc_status} => NOT EDITABLE, REDIRECT TO /${lang}`);
      return router.createUrlTree([`/${lang}`]);
    })
  );
};
